<template>
  <fade-down-modal class="global-msg" :show="showState">
    <div style="background:#fff;margin: 0 auto;" :style="{ width: modalWidth + 'px' }">
      <div class="header">
        <header-tag :title="title"></header-tag>
      </div>
      <div class="body">
        <div :class="{
          success: type == 'success',
          error: type == 'error',
          info: type == 'info'
        }">
          <div>
            <img src="@/assets/img/icon/u410.svg" alt="" v-show="type == 'success'" />
            <img src="@/assets/img/icon/u402.svg" alt="" v-show="type == 'error'" />
            <span v-text="msgLeft"></span>
            <span v-text="msgCenter" style="color:red"></span>
            <span v-text="msg"></span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="right">
          <a href="#" v-show="confirmBtn" class="blue-btn" @click.prevent="confirm"
            style="padding: 0;line-height: 30px;position: relative;">
            <img src="@/assets/img/icon/u43.png" alt="" v-show="confirmImg == 1"
              style="width: 24px;position: absolute;top: 2px;left:7px;margin-right: 2px;" />
            <img src="@/assets/img/icon/u44.png" alt="" v-show="confirmImg == 2"
              style="width: 24px;position: absolute;top: 2px;left:3px;margin-right: 2px;" />
            <span v-text="confirmTxt" :style="{ 'margin-left': confirmImg ? '24px' : 0 }"></span>
          </a>
          <a href="#" v-show="cancleBtn" class="default-btn" @click.prevent="cancle" v-text="cancelTxt"></a>
        </div>
      </div>
    </div>
  </fade-down-modal>
</template>
<script>
// 头部tag内容
import HeaderTag from "_c/tagTitle/headerTag";
import FadeDownModal from "_c/modals/fadeDown";
export default {
  components: {
    HeaderTag,
    FadeDownModal
  },
  data () {
    return {
      showState: false,
      msg: "",
      msgLeft: "",
      msgCenter: "",
      type: "",
      confirmBtn: true,
      cancleBtn: false,
      modalWidth: 600,
      title: "",
      confirmTxt: "确定",
      cancelTxt: "取消",
      confirmFn: null,
      cancleFn: null,
      confirmImg: 0
    };
  },
  mounted () {
    window.$Message = {};
    window.$Message.show = obj => {
      this.show(obj);
    };
    window.$Message.hide = () => {
      this.hide();
    };
  },
  methods: {
    /* eslint-disable */
    show ({
      type,
      cancle,
      msgLeft,
      msgCenter,
      msg,
      confirmBtn,
      cancleBtn,
      confirmImg,
      modalWidth,
      title,
      confirmTxt,
      cancelTxt,
      confirmFn,
      cancleFn
    }) {
      this.confirmBtn = this.defaultVal(confirmBtn, true);
      this.cancleBtn = this.defaultVal(cancleBtn, false);
      this.confirmImg = this.defaultVal(confirmImg, 0);
      this.type = this.defaultVal(type, "info");
      this.msgLeft = this.defaultVal(msgLeft, "");
      this.msgCenter = this.defaultVal(msgCenter, "");
      this.msg = this.defaultVal(msg, "");
      this.modalWidth = this.defaultVal(modalWidth, 600);
      this.title = this.defaultVal(title, "提示");
      this.confirmTxt = this.defaultVal(confirmTxt, "确定");
      this.cancelTxt = this.defaultVal(cancelTxt, "取消");
      this.showState = true;
      if (confirmFn !== undefined)
      {
        this.confirm = confirmFn;
      }
      if (cancleFn !== undefined)
      {
        this.cancleFn = cancleFn;
      }
    },
    defaultVal (val, defaultVal) {
      if (val !== undefined)
      {
        return val;
      } else
      {
        return defaultVal;
      }
    },
    hide () {
      this.showState = false;
    },
    confirm () {
      this.showState = false;
      if (this.confirmFn !== null)
      {
        this.confirmFn();
        setTimeout(() => {
          this.confirmFn = null;
        });
      }
      this.$emit("confirm");
    },
    cancle () {
      this.showState = false;
      if (this.cancleFn !== null)
      {
        this.cancleFn();
        this.cancleFn = null;
      }
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss" scoped>
.global-msg {
  z-index: 900;
}

.header {
  height: 50px;
  line-height: 50px;
  text-align: left;
  padding-left: 30px;
  border-bottom: 1px solid #e5e5e5;
}

.bottom {
  overflow: hidden;
  text-align: right;
  padding-right: 30px;
  padding-left: 30px;
  height: 70px;
  border-top: 1px solid #e5e5e5;

  a {
    min-width: 90px;
    text-align: center;
  }

  a+a {
    margin-left: 10px;
  }

  .right {
    padding: 20px;
  }
}

.body {
  padding: 20px;
  text-align: left;

  img {
    position: relative;
    top: 5px;
    margin-right: 5px;
  }

  >div {
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
    // font-size: 16px;
    font-size: 12px;
    color: #515151;
  }
}

.error {
  color: #ff3333;
}
</style>
